/**
 * Created by Jose Luis Falcon on 2017-09-06.
 * Reports Service
 */
import axios from 'axios';
import { serializeParams } from '../common/helpers';
import { apiUrl } from '../app.config';
import request from './request';


export const get = (url = '', params = {}) => {

    return request().get(`${url}${serializeParams(params)}`)
        .then(response => {
            return response.data;
        })
        .catch(error => {
          console.log("eRrro");
            return error;
        });
};



// WEBPACK FOOTER //
// ./services/reports.js